
const KeyCodes = Object.freeze({
  BACKSPACE: 8,
  TAB: 9,
  ENTER: 13,
  SHIFT: 16,
  CTRL: 17,
  ESC: 27,
  SPACE_BAR: 32,
  LEFT: 37,
  UP: 38,
  RIGHT: 39,
  DOWN: 40,
  DELETE: 46,
  A: 65,
  B: 66,
  C: 67,
  D: 68,
  E: 69,
  F: 70,
  G: 71,
  O: 79,
  P: 80,
  R: 82,
  V: 86,
  Y: 89,
  Z: 90,
  COMMAND: 91,
  F11: 122
});

export default KeyCodes;



// WEBPACK FOOTER //
// ./src/assets/javascripts/nesting/keycodes.js